import { useCallback } from "react";

import PropTypes from "prop-types";

import { apiClient } from "@/features/shared";
import { CustomAutocomplete } from "@/features/ui";

export const SellerBankAccountSelect = ({
  sellerableId,
  sellerableType,
  value,
  onChange,
  ...props
}) => {
  const fetchSellerBankAccounts = useCallback(async () => {
    if (!sellerableId || !sellerableType) return [];

    const {
      data: { data },
    } = await apiClient.get("seller-bank-accounts", {
      params: {
        sellerableId,
        sellerableType,
      },
    });

    // Resolve an id-less prefill (e.g. a snapshot from a transaction
    // that doesn't store seller_bank_accounts.id) to the canonical
    // SBA option so the form submits the correct id.
    if (value && !value.id) {
      const matched = data.find(
        (option) =>
          option.accountNumber === value.accountNumber &&
          option.bank?.id === value.bank?.id
      );
      if (matched) onChange(matched);
    }

    return data;
  }, [sellerableId, sellerableType, value, onChange]);

  return (
    <CustomAutocomplete
      fetchOptions={fetchSellerBankAccounts}
      value={value}
      onChange={onChange}
      getOptionLabel={(option) =>
        option.accountNumber + " - " + option.bank.name
      }
      isOptionEqualToValue={(option, selectedOption) =>
        option.accountNumber === selectedOption.accountNumber
      }
      {...props}
    />
  );
};

SellerBankAccountSelect.propTypes = {
  sellerableId: PropTypes.string,
  sellerableType: PropTypes.oneOf(["SUPPLIER", "OUTLET"]),
  value: PropTypes.object,
  onChange: PropTypes.func,
  TextFieldProps: PropTypes.object,
};
